import { api } from "@/lib/api";

import type {
  CreateProductRecipeReq,
  ProductRecipe,
  ProductRecipeListRes,
} from "@artisancode/api-types";

export const productRecipeService = {
  getByProduct: (productId: string, params?: { workspace_id?: string }) =>
    api.get<ProductRecipeListRes>(
      `/products/${productId}/recipes`,
      params as Record<string, string | number | boolean | undefined>,
    ),

  create: (productId: string, body: CreateProductRecipeReq) =>
    api.post<ProductRecipe>(`/products/${productId}/recipes`, body),

  activate: (productId: string, recipeId: string) =>
    api.post<ProductRecipe>(
      `/products/${productId}/recipes/${recipeId}/activate`,
      {},
    ),
};
